<template lang="pug">
  multiselect(
    :value="value"
    :options="currencyList"
    placeholder="Type to search"
    label="Desc_en"
    track-by="Desc_en"
    name="code"
    @input="onInput"
    :disabled="disabled"
    :loading="currency_loading"
    :internalSearch="true"
    @search-change="loadCurrency"
  )
    template(slot="option" slot-scope="props")
      span.block {{ props.option.Desc_en }}
</template>

<script>
import jsonData from './e-invoice/Description.json';
import _ from 'lodash';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currencyList: [],
            currency_loading: false,
        };
    },
    mounted() {
        this.loadCurrency();
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        },
        loadCurrency: _.debounce(function(query) {
            this.currency_loading = true;

            if (query) {
                this.currencyList = jsonData.filter(item =>
                    item.Desc_en.toLowerCase().includes(query.toLowerCase()),
                );
            } else {
                this.currencyList = jsonData;
            }

            this.currency_loading = false;
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/eDescriptionSelector.vue